<mat-radio-group [(ngModel)]="selectedOption" fxLayout="row" (change)="setResolution()" name="screenResolution">
  <mat-radio-button [value]="1">Desktop</mat-radio-button>
  <mat-radio-button [value]="0">Mobile</mat-radio-button>
</mat-radio-group>

<div style="font-size: 12px; margin-left: 20px; font-weight: 600">Screen Resolution {{ selectedOption == 0 ? "<" : ">" }} 760 px</div>
